import i18n from "~/i18n";

export const BTN_STATUS = {
	심사대기: ["info", "setting", "delete"],
	심사중: ["info", "setting", "close", "delete"],
	심사완료: ["info", "setting", "result"],
};

export const BTN_TEXT = {
	info: i18n.t("pages.apply.ApplySetting.ProcessingModal.Three.btn-info"),
	setting: i18n.t("pages.apply.ApplySetting.ProcessingModal.Three.btn-setting"),
	// judge: i18n.t("pages.apply.ApplySetting.ProcessingModal.Three.btn-judge"),
	result: i18n.t("pages.apply.ApplySetting.ProcessingModal.Three.btn-result"),
	delete: i18n.t("pages.apply.ApplySetting.ProcessingModal.Three.btn-delete"),
	close: "심사마감"
};

// 심사 상태
export const TRANS_STATUS = {
	심사대기: i18n.t("pages.apply.ApplyEval.ApplyEvalPopup.waitingJudge"),
	심사중: i18n.t("pages.apply.ApplyManage.applyMangeListTable.underEvaluate"),
	심사완료: i18n.t("pages.apply.ApplyEval.ApplyEvalPopup.doneEvaluate"),
};

// 국가
export const COUNTRY_KOREAN = {
	korea: "한국",
	japan: "일본",
	usa: "미국",
	america: "미국",
	china: "중국",
	vietnam: "베트남",
	etc: "기타",
};
